import { Link } from 'react-router-dom';
import { CheckCircle as CheckCircle2, HouseLine as Home } from "@phosphor-icons/react";

export default function CompletionScreen() {
  return (
        <div className="min-h-screen flex flex-col">
          {/* Navigation */}
          <nav className="px-4 sm:px-6 lg:px-8 py-4" style={{ background: 'rgba(253, 251, 247, 0.95)' }}>
            <div className="max-w-7xl mx-auto flex items-center justify-between">
              <Link 
                to="/" 
                className="flex items-center gap-2 font-body text-sm transition-opacity hover:opacity-80"
                style={{ color: '#2A1E5C' }}
              >
                <Home className="w-4 h-4" />
                paydayrelay.com
              </Link>
            </div>
          </nav>

          {/* Success Content */}
          <div className="flex-1 flex items-center justify-center px-6 py-16">
            <div className="max-w-lg text-center">
              <div className="w-20 h-20 mx-auto mb-8 rounded-full flex items-center justify-center" style={{ background: 'rgba(76, 175, 80, 0.15)' }}>
                <CheckCircle2 className="w-10 h-10" style={{ color: '#4CAF50' }} />
              </div>
              
              <h1 className="font-heading text-3xl sm:text-4xl font-bold mb-4" style={{ color: '#2A1E5C' }}>
                Your Income Map Is On Its Way
              </h1>
              
              <p className="font-body text-lg mb-6" style={{ color: '#5D5A6B' }}>
                Check your inbox for your full results. Your weekly target, daily breakdown, tax estimates, and 12-month trajectory are all in there.
              </p>
              
              <div className="p-6 rounded-xl mb-8" style={{ background: 'rgba(42, 30, 92, 0.05)' }}>
                <p className="font-body text-base mb-2" style={{ color: '#2A1E5C' }}>
                  <strong>What to do next:</strong>
                </p>
                <p className="font-body text-sm" style={{ color: '#5D5A6B' }}>
                  Save the PDF somewhere you'll see it. Use your daily target as your compass this week. Every Sunday, ask yourself: did I hit my weekly number?
                </p>
              </div>
              
              <p className="font-body text-sm mb-8" style={{ color: '#8B7E6A' }}>
                Didn't get it? Check your spam folder or email <a href="mailto:support@paydayrelay.com" className="underline" style={{ color: '#2A1E5C' }}>support@paydayrelay.com</a>
              </p>
              
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-body font-medium transition-all hover:scale-105"
                style={{ background: '#F5CB5C', color: '#2A1E5C' }}
              >
                <Home className="w-4 h-4" />
                Back to Home
              </Link>
            </div>
          </div>

          {/* Simple Footer */}
          <footer className="py-6 px-6 text-center" style={{ borderTop: '1px solid rgba(42, 30, 92, 0.1)' }}>
            <p className="font-body text-xs leading-relaxed" style={{ color: '#8B7E6A' }}>
              © 2026 Earthwise Digital LLC. Payday Relay and Payday Relay Method are proprietary educational frameworks and product assets of Earthwise Digital LLC. All rights reserved.
            </p>
            <div className="mt-2">
              <Link to="/privacy" className="font-body text-xs hover:opacity-70" style={{ color: '#8B7E6A' }} data-testid="footer-privacy-link">
                Privacy Policy
              </Link>
              <span className="mx-3"> </span>
              <Link to="/terms" className="font-body text-xs hover:opacity-70" style={{ color: '#2A1E5C' }} data-testid="footer-terms-link">
                Terms of Service
              </Link>
            </div>
            <p className="font-body text-xs mt-2" style={{ color: '#A79885' }}>
              © {new Date().getFullYear()} Earthwise Digital LLC. All rights reserved.
            </p>
          </footer>
        </div>
  );
}
